module.exports = __webpack_public_path__ + "bfe9a6a12ac354ba7cc9b75ea11c303a.pdf";